import React from "react";
import { Reveal, Overline } from "../components/site/Reveal";
import { TechLines } from "../components/site/TechLines";
import { IMAGES } from "../data/content";

const FEATURES = ["AI", "Automation", "ERP", "Data analytics", "Predictive insights", "Digital workflow", "Smart decision-making"];

export const Technology = () => (
  <section id="technology" className="relative overflow-hidden bg-emerald-darkest py-24 text-off-white sm:py-32" data-testid="technology-section">
    <TechLines className="opacity-70" />
    <div className="grain absolute inset-0" />
    <div className="relative z-10 mx-auto grid max-w-[1400px] items-center gap-16 px-5 sm:px-8 lg:grid-cols-2">
      <Reveal>
        <div className="relative overflow-hidden rounded-[2rem] border border-white/10 shadow-2xl">
          <img src={IMAGES.tech} alt="Humanoid robot with global data networks" className="w-full object-cover transition-transform duration-700 hover:scale-105" />
          <div className="absolute inset-0 bg-gradient-to-t from-emerald-darkest/70 via-transparent to-transparent" />
        </div>
      </Reveal>

      <div>
        <Reveal><Overline dark>Technology & Innovation</Overline></Reveal>
        <Reveal delay={0.05}>
          <h2 className="mt-6 font-serif text-4xl font-light leading-tight sm:text-5xl lg:text-6xl">
            Human Expertise. Intelligent Technology. <span className="text-gradient-gold">Better Decisions.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-8 max-w-xl text-base leading-relaxed text-off-white/70 sm:text-lg">
            We believe the future of consulting is the combination of human judgement, organisational experience,
            analytics, automation and artificial intelligence — working together to deliver better decisions.
          </p>
        </Reveal>
        <Reveal delay={0.15}>
          <div className="mt-8 flex flex-wrap gap-2.5">
            {FEATURES.map((f) => (
              <span key={f} className="glass rounded-full px-4 py-2 text-sm font-medium text-off-white/90">{f}</span>
            ))}
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
